var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftEdge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8306)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8306",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3478 36.7432C43.7035 37.0781 43.0391 37.3728 42.3584 37.6256C40.2031 38.428 37.9206 38.8349 35.6208 38.8268C26.7438 38.8268 19.0113 32.7249 19.0113 24.8771C19.0229 23.8264 19.3141 22.7977 19.8551 21.897C20.396 20.9962 21.1672 20.2558 22.0893 19.752C14.0566 20.0899 11.9922 28.4635 11.9922 33.3637C11.9922 47.257 24.773 48.6464 27.5318 48.6464C29.0145 48.6464 31.2479 48.2146 32.5991 47.7827L32.8433 47.7076C38.015 45.9194 42.4235 42.4231 45.3426 37.7945C45.4275 37.6539 45.4639 37.4894 45.4463 37.3261C45.4287 37.1628 45.3581 37.0097 45.2452 36.8904C45.1323 36.7711 44.9834 36.6921 44.8213 36.6655C44.6593 36.6389 44.4929 36.6662 44.3479 36.7432H44.3478Z",
    fill: "url(#paint0_linear_27_8306)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M44.3478 36.7432C43.7035 37.0781 43.0391 37.3728 42.3584 37.6256C40.2031 38.428 37.9206 38.8349 35.6208 38.8268C26.7438 38.8268 19.0113 32.7249 19.0113 24.8771C19.0229 23.8264 19.3141 22.7977 19.8551 21.897C20.396 20.9962 21.1672 20.2558 22.0893 19.752C14.0566 20.0899 11.9922 28.4635 11.9922 33.3637C11.9922 47.257 24.773 48.6464 27.5318 48.6464C29.0145 48.6464 31.2479 48.2146 32.5991 47.7827L32.8433 47.7076C38.015 45.9194 42.4235 42.4231 45.3426 37.7945C45.4275 37.6539 45.4639 37.4894 45.4463 37.3261C45.4287 37.1628 45.3581 37.0097 45.2452 36.8904C45.1323 36.7711 44.9834 36.6921 44.8213 36.6655C44.6593 36.6389 44.4929 36.6662 44.3479 36.7432H44.3478Z",
    fill: "url(#paint1_radial_27_8306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8123 46.2808C19.1417 45.2427 17.6936 43.8834 16.5521 42.2817C15.2484 40.4966 14.351 38.4478 13.9229 36.2792C13.4948 34.1105 13.5463 31.8745 14.0738 29.7278C14.6013 27.5812 15.5921 25.5759 16.9766 23.8527C18.3611 22.1295 20.1059 20.73 22.0885 19.7524C22.6891 19.4708 23.6837 18.9827 25.0162 19.0015C25.954 19.0088 26.8773 19.2329 27.7141 19.6563C28.5508 20.0797 29.2783 20.6909 29.8396 21.4422C30.5948 22.458 31.0089 23.6868 31.0225 24.9525C31.0225 24.915 35.6201 10.0078 16.0078 10.0078C7.76876 10.0078 0.99317 17.8182 0.99317 24.6897C0.960628 28.3193 1.73652 31.9107 3.26456 35.2031C5.76543 40.5327 10.1365 44.7582 15.5477 47.0771C20.9589 49.3961 27.0333 49.647 32.6173 47.7822C30.6612 48.4003 28.5941 48.5861 26.5591 48.3267C24.5241 48.0674 22.5698 47.3692 20.8312 46.2803L20.8123 46.2808Z",
    fill: "url(#paint2_linear_27_8306)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M20.8123 46.2808C19.1417 45.2427 17.6936 43.8834 16.5521 42.2817C15.2484 40.4966 14.351 38.4478 13.9229 36.2792C13.4948 34.1105 13.5463 31.8745 14.0738 29.7278C14.6013 27.5812 15.5921 25.5759 16.9766 23.8527C18.3611 22.1295 20.1059 20.73 22.0885 19.7524C22.6891 19.4708 23.6837 18.9827 25.0162 19.0015C25.954 19.0088 26.8773 19.2329 27.7141 19.6563C28.5508 20.0797 29.2783 20.6909 29.8396 21.4422C30.5948 22.458 31.0089 23.6868 31.0225 24.9525C31.0225 24.915 35.6201 10.0078 16.0078 10.0078C7.76876 10.0078 0.99317 17.8182 0.99317 24.6897C0.960628 28.3193 1.73652 31.9107 3.26456 35.2031C5.76543 40.5327 10.1365 44.7582 15.5477 47.0771C20.9589 49.3961 27.0333 49.647 32.6173 47.7822C30.6612 48.4003 28.5941 48.5861 26.5591 48.3267C24.5241 48.0674 22.5698 47.3692 20.8312 46.2803L20.8123 46.2808Z",
    fill: "url(#paint3_radial_27_8306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5786 28.9135C29.4097 29.1013 28.9405 29.3828 28.9405 29.9648C28.9405 30.4531 29.2596 30.9414 29.8414 31.3354C32.5252 33.2129 37.6112 32.9501 37.63 32.9501C39.6308 32.9488 41.5946 32.4106 43.3166 31.3918C45.0505 30.377 46.4892 28.9267 47.4899 27.1846C48.4907 25.4426 49.0188 23.4692 49.022 21.4602C49.0783 17.2546 47.5205 14.4571 46.9012 13.218C42.9036 5.44492 34.3269 0.976562 24.9992 0.976562C11.8603 0.976562 1.15996 11.5325 0.976562 24.6728C1.07041 17.8173 7.8831 12.279 15.9907 12.279C16.6476 12.279 20.4012 12.3354 23.8731 14.1564C26.3126 15.3692 28.3326 17.2853 29.6724 19.6574C30.8172 21.6476 31.0236 24.1821 31.0236 25.196C31.0236 26.2099 30.5169 27.6931 29.5598 28.9322L29.5786 28.9135Z",
    fill: "url(#paint4_radial_27_8306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5786 28.9135C29.4097 29.1013 28.9405 29.3828 28.9405 29.9648C28.9405 30.4531 29.2596 30.9414 29.8414 31.3354C32.5252 33.2129 37.6112 32.9501 37.63 32.9501C39.6308 32.9488 41.5946 32.4106 43.3166 31.3918C45.0505 30.377 46.4892 28.9267 47.4899 27.1846C48.4907 25.4426 49.0188 23.4692 49.022 21.4602C49.0783 17.2546 47.5205 14.4571 46.9012 13.218C42.9036 5.44492 34.3269 0.976562 24.9992 0.976562C11.8603 0.976562 1.15996 11.5325 0.976562 24.6728C1.07041 17.8173 7.8831 12.279 15.9907 12.279C16.6476 12.279 20.4012 12.3354 23.8731 14.1564C26.3126 15.3692 28.3326 17.2853 29.6724 19.6574C30.8172 21.6476 31.0236 24.1821 31.0236 25.196C31.0236 26.2099 30.5169 27.6931 29.5598 28.9322L29.5786 28.9135Z",
    fill: "url(#paint5_radial_27_8306)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_8306",
    x1: 11.9922,
    y1: 15.8223,
    x2: 45.4841,
    y2: 15.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_27_8306",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.1204 -14.2597) scale(17.9023 17.0188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27_8306",
    x1: 29.6445,
    y1: 30.3327,
    x2: 5.04302,
    y2: 12.7123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_27_8306",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-30.099 -12.9515) rotate(-79.4048) scale(21.9556 26.6608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_27_8306",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2612 6.79201) rotate(91.4335) scale(57.0885 53.9118)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#36C752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_27_8306",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.7315 41.0226) rotate(79.0348) scale(26.8272 10.0981)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66EB6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftEdge);
export default __webpack_public_path__ + "static/media/MicrosoftEdge.a25fd102cbb75d2815f1db6686c70b71.svg";
export { ForwardRef as ReactComponent };